import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

interface Template {
  id: number;
  name: string;
}

interface TemplateSelectorProps {
  templates: Template[];
  selectedTemplateId?: number | null;
  onTemplateChange: (templateId: number | null) => void;
  isLoading?: boolean;
  disabled?: boolean;
}

export function TemplateSelector({
  templates,
  selectedTemplateId,
  onTemplateChange,
  isLoading = false,
  disabled = false,
}: TemplateSelectorProps) {
  // Si solo hay una plantilla, no mostrar el selector
  if (templates.length <= 1) {
    return null;
  }

  if (isLoading) {
    return (
      <div className="space-y-2">
        <Label>Plantilla de Reporte</Label>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span>Cargando plantillas...</span>
        </div>
      </div>
    );
  }

  if (templates.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2">
      <Label htmlFor="template-selector">Plantilla de Reporte</Label>
      <Select
        value={selectedTemplateId?.toString() || ""}
        onValueChange={(value) => onTemplateChange(value ? parseInt(value) : null)}
        disabled={disabled}
      >
        <SelectTrigger id="template-selector" className="w-full">
          <SelectValue placeholder="Seleccionar plantilla" />
        </SelectTrigger>
        <SelectContent>
          {templates.map((template) => (
            <SelectItem key={template.id} value={template.id.toString()}>
              {template.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="text-xs text-muted-foreground">
        Selecciona la plantilla que deseas usar para generar el reporte
      </p>
    </div>
  );
}

